export default __webpack_public_path__ + "static/media/hm.4050b3f5.svg";